import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import TextHighlighter, { HighlightType } from '../../../components/text-highlighter';
import { exercisePropTypes } from '../../../constants/exercise';
import FluidContainer from '../../layouts/components/fluid-container';
import Spacer from '../../spacer';

export const AnswersContainer = styled.div`
    padding: ${(props) => (props.isMobile ? '24px 32px 24px 32px' : '24px 32px 24px 32px')};
`;

export const Label = styled.span`
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 24px;
`;

const getGreenWords = (correctWords, correctSelections) => {
    return correctWords
        .filter((correct) => correctSelections.find((selection) => selection.id === correct.id))
        .map((word) => ({ ...word, type: HighlightType.CORRECT }));
};

const getGreyWords = (correctWords, correctSelections) => {
    return correctWords
        .filter((correct) => !correctSelections.find((el) => el.id === correct.id))
        .map((word) => ({ ...word, type: HighlightType.MISSING }));
};

export const getHighlightedWords = (answers, correctWords, wrongWords) => {
    const correctSelections = wrongWords.filter((wrong) =>
        answers.find((answer) => answer.start === wrong.start && answer.end === wrong.end),
    );

    const greenWords = getGreenWords(correctWords, correctSelections);
    const greyWords = getGreyWords(correctWords, correctSelections);
    return [...greenWords, ...greyWords];
};

const FindErrorFeedback = ({ answers, exercise }) => {
    const { correctWords, wrongWords } = exercise;

    return (
        <FluidContainer
            marginTop={['mobile', 'mobile', 'desktop']}
            flexDirection="column"
            marginLeft="regular"
            marginRight="regular"
            paddingBottom="mobile"
        >
            <Label>{'La risposta esatta è:'}</Label>
            <Spacer size="xs" />
            <TextHighlighter
                question={exercise.plainQuestionCorrect}
                highlights={getHighlightedWords(answers, correctWords, wrongWords)}
                disabled={true}
            />
        </FluidContainer>
    );
};
FindErrorFeedback.propTypes = {
    exercise: PropTypes.shape({
        ...exercisePropTypes.propTypes,
        plainQuestionCorrect: PropTypes.string,
        plainQuestionWrong: PropTypes.string,
        correctWords: PropTypes.arrayOf(PropTypes.object),
        wrongWords: PropTypes.arrayOf(PropTypes.object),
    }),
    answers: PropTypes.array,
};

export default FindErrorFeedback;
